exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control.w-25[data-v-1c38e87f] {\n    display: inline-block;\n}\n.btn.btn-primary.mr-2[data-v-1c38e87f] {\n    margin-bottom: 1px;\n    margin-left: 10px;\n}\n", ""]);

// exports
